import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg, LOGO_URL } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] text-[#F8FAFC] flex items-center justify-center p-5 relative grain">
      <div className="absolute -left-20 top-10 w-72 h-72 rounded-full bg-[#E2705A]/10 blur-3xl" />
      <div data-testid="admin-login-card" className="relative w-full max-w-md bg-[#1B2A41] border border-[#2C3E55] rounded-2xl p-8 shadow-2xl">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-[#8FA58A] hover:text-[#E2705A] mb-6" data-testid="admin-back-home">
          <ArrowLeft className="w-3 h-3" /> Back to site
        </Link>
        <img src={LOGO_URL} alt="R.O.A.N" className="w-24 mb-4" />
        <h1 className="font-type font-bold text-2xl">Admin sign in</h1>
        <p className="text-sm text-[#F8FAFC]/60 mt-1">R.O.A.N Initiative control panel</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="font-type text-xs uppercase tracking-wider text-[#8FA58A]">Email</Label>
            <Input id="email" type="email" data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11 bg-[#121E2B] border-[#2C3E55] text-[#F8FAFC]" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="font-type text-xs uppercase tracking-wider text-[#8FA58A]">Password</Label>
            <Input id="password" type="password" data-testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11 bg-[#121E2B] border-[#2C3E55] text-[#F8FAFC]" />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-[#E2705A] bg-[#E2705A]/10 rounded-lg px-3 py-2">{error}</p>
          )}
          <button type="submit" disabled={busy} data-testid="admin-login-button" className="w-full h-12 rounded-full bg-[#E2705A] hover:bg-[#D35D46] disabled:opacity-60 font-type font-bold uppercase tracking-wider text-sm inline-flex items-center justify-center gap-2 transition-colors">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
